export default {
    "en": {
        monthly: {
            year: 'numeric', month: 'short'
        },
        daymonth: {
            month: 'short', day: 'numeric'
        },
        fulldaymonth: {
            month: 'long', day: 'numeric', year: 'numeric'
        },
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        prestige: {
            day: '2-digit', month: '2-digit', year: '2-digit' 
        },
        long: {
            year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
        },
        timestamp1: {
            month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
        }
    },
    "fr": {
        monthly: {
            year: 'numeric', month: 'short'
        },
        daymonth: {
            month: 'short', day: 'numeric'
        },
        fulldaymonth: {
            month: 'long', day: 'numeric', year: 'numeric'
        },
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        prestige: {
            day: '2-digit', month: '2-digit', year: '2-digit' 
        },
        long: {
            year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
        },
        timestamp1: {
            month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
        }
    }
}